<h2 id="{{ prefixId }}_kinderHeader_txt">Kind(er)</h2>
<div [formGroup]="formGroup">
    <div formArrayName="kinder" *ngFor="let kind of kinder.controls; let i = index">
        <div [formGroupName]="i">
            <div [formGroup]="kinder.controls[i]">
                <div class="row">
                    <div class="col-lg-12 col-md-10 col-xs-12">
                        <div class="row ba-form-row">
                            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-3">
                                <px-date
                                    id="{{ prefixId }}_kindGeburtsdatum_{{ i }}"
                                    formControlName="kindGeburtsdatum"
                                    placeholder="TT.MM.JJJJ"
                                >
                                    Geburtsdatum
                                </px-date>
                            </div>

                            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3">
                                <px-input
                                    id="{{ prefixId }}_kindVorname_{{ i }}"
                                    formControlName="kindVorname"
                                    maxLength="30"
                                >
                                    Vorname
                                </px-input>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3" *ngIf="prefixId === 'vm'">
                                <px-input
                                    id="{{ prefixId }}_kindAbweichenderNachname_{{ i }}"
                                    label="abweichender Nachname"
                                    formControlName="kindAbweichenderNachname"
                                    maxLength="30"
                                    >abweichender Nachname
                                    <button
                                        id="{{ prefixId }}_abweichenderNachnameModalDialog_help"
                                        type="button"
                                        pxTooltip="help"
                                        trigger="click"
                                        title="abweichender Nachname"
                                        content="Tragen Sie hier den Nachnamen des Kindes ein, falls dieser vom Nachnamen des Mitarbeiters abweicht."
                                    ></button>
                                </px-input>
                            </div>
                            <div class="col-lg-2 padding-top-10" *ngIf="kinder.controls.length > 1">
                                <px-button
                                    buttonStyleType="secondary"
                                    styleClass="ba-btn-icon ba-icon-trash"
                                    id="{{ prefixId }}_loeschen_{{ i }}"
                                    (buttonClicked)="kindLoeschen(i)"
                                    >Löschen</px-button
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row weiteres-kind-btn">
        <div class="col-lg-4">
            <px-button
                id="{{ prefixId }}_kindHinzufuegen"
                buttonStyleType="secondary"
                styleClass="ba-btn-icon ba-icon-plus"
                (buttonClicked)="kindHinzufuegen()"
                >Weiteres Kind
            </px-button>
        </div>
    </div>
</div>
